skrilla.service('valuesToWordsService', function($q){

    let dictionary = {
        id: "Id",
        status: "Status",
        username: "Username",
        firstName: "First Name",
        middleName: "Middle Name",
        lastName: "Last Name",
        fullName: "Full Name",
        phone: "Phone Number",
        email: "Email",
        tags: "User Tags",
        gender: "Gender",
        country: "Country",
        verificationStatus: "Verification Status",
        dateOfBirth: "Date Of Birth",
        addressLine: "Address Line",
        postcode: "Post Code",
        street: "Street",
        suburb: "Suburb",
        state: "State",
        matches: "Contest Matches",
        players: "Contest Players",
        contestType: "Contest Type",
        description: "Description",
        cardImageUri: "Card Image URI",
        entryFee: "Entry Fee",
        entryFeeCurrency: "Currency Type",
        startTime: "Start Time",
        salaryCap: "Salary Cap",
        maximumEntries: "Maximum Contest Rosters",
        maximumEntriesPerUser: "Maximum Rosters Per User",
        pointsPerKill: "Points Per Kill",
        pointsPerAssist: "Points Per Assist",
        pointsPerDeath: "Points Per Death",
        pointsPerHeadshot: "Points Per Headshot",
        pointsPerRoundWon: "Points Per Rounds Won",
        pointsPerRoundsLost: "Points Per Rounds Lost",
        pointsPerTargetBombed: "Points Per Target Bombed",
        pointsPerBombDefused:"Points Per Bomb Defused",
        prizePool: "Prize Pool",
        roleName: "Role Name",
        createdAt: "Created At"
    };

    let googleMapIdsToUserFields = {
        street_number: 'streetNumber',
        route: 'street',
        locality: 'suburb',
        administrative_area_level_1: 'state',
        country: 'country',
        postal_code: 'postCode'
    }

    let getWord = function(key){
        let keys = key.split(".")
        if(keys.length > 0){
            key = keys[keys.length - 1];
        }
        let word = dictionary[key]
        return word ? word: key
    }

    let getUserFieldFromGoogleMapsKey = function(key){
        return googleMapIdsToUserFields[key];
    }

    return {
        getWord: getWord,
        getUserFieldFromGoogleMapsKey: getUserFieldFromGoogleMapsKey
    };
});

